import { IShift } from '~/models';
import {
  IDashboardJob,
  IDashboardJobApi,
  IDashboardJobsInfo,
  IDashboardJobsInfoApi,
} from './dashboardJobsTypes';

function toDashboardJob(dashboardJobApi: IDashboardJobApi): IDashboardJob {
  return {
    id: dashboardJobApi.id,
    office: {
      id: dashboardJobApi.offer_owner.id,
      name: dashboardJobApi.offer_owner.office_name,
    },
    professional: {
      id: dashboardJobApi.offer_final_reciever?.id ?? '',
      firstName: dashboardJobApi.offer_final_reciever?.first_name ?? '',
      lastName: dashboardJobApi.offer_final_reciever?.last_name ?? '',
    },
    procedures: dashboardJobApi.procedures,
    rate: dashboardJobApi.rate,
    specialty: dashboardJobApi.specialty,
    professionName: dashboardJobApi.professionName,
    subProfession: dashboardJobApi.subProfession,
    startTime: dashboardJobApi.local_start_time,
    endTime: dashboardJobApi.local_end_time,
    date: dashboardJobApi.local_date,
    lunchBreakTime: dashboardJobApi.lunch_break_time,
    amount: dashboardJobApi.amount,
    autoFill: dashboardJobApi.autoFill,
    isAssistedHygiene: dashboardJobApi.isAssistedHygiene,
    multipleCounters: dashboardJobApi.multipleCounters,
    jobFilledDatetime: dashboardJobApi.job_filled_datetime,
    dashboardJobApi: dashboardJobApi as unknown as IShift,
  };
}

function toDashboardJobsInfo(dashboardJobsInfoApi: IDashboardJobsInfoApi): IDashboardJobsInfo {
  return {
    filledCount: dashboardJobsInfoApi.scheduled,
    pendingCount: dashboardJobsInfoApi.actionRequired,
    openCount: dashboardJobsInfoApi.activeRequest,
    pendingReviewJobCount: dashboardJobsInfoApi.pendingReviewJobCount,
    todayShiftCount: dashboardJobsInfoApi.todayShift,
  };
}

export const dashboardJobsAdapter = { toDashboardJob, toDashboardJobsInfo };
